import { type ComponentType } from 'react';
import { getPlatformComponent } from '@direct-frontend/platform-code';
import { type GridPageLayoutComponentProps } from './types';

export type { GridPageLayoutProps } from './types';

export const GridPageLayout = getPlatformComponent<ComponentType<GridPageLayoutComponentProps>>({
    desktop: import('./GridPageLayout@desktop'),
    mobile: import('./GridPageLayout@mobile'),
});
